module.exports = __webpack_public_path__ + "static/media/avatar-6.a1be6a05.svg";